import React, { useContext } from "react";
import { AddressForm, AddressFormData, isValidMobile } from "modules/auth";
import { Button, Input, phoneRegex } from "modules/common";
import { updateAccountMetadata, updateMobileNumber } from "modules/dashboard";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "store";
import { ProfileInfo } from "./ProfileInfo";
import { useForm } from "modules/common/hooks/useForm";
import { AccessibilityContext } from "views/AccessibilityContext";

interface FormData extends AddressFormData {
    mobileNumber: string;
}

export const ProfileInfoCitizenForm: React.FC = () => {
    const dispatch = useDispatch();
    const { profile } = useSelector((state: RootState) => state.profile);

    const form = useForm<FormData>({
        initialValue: {
            mobileNumber: profile?.mobileNumber || "",
            postalNumber: profile?.postalNumber,
            street: profile?.street,
            streetNumber: profile?.streetNumber,
            county: !profile?.countyId
                ? undefined
                : {
                      label: profile.county,
                      value: Number(profile.countyId),
                  },
            settlement: !profile?.settlementId
                ? undefined
                : {
                      label: profile.settlement,
                      value: Number(profile.settlementId),
                  },
        },
        validators: {
            mobileNumber: [
                number =>
                    Promise.resolve(
                        isValidMobile(number) ? "Kontakt broj nije u ispravnom formatu" : undefined
                    ),
            ],
        },
        classes: {
            label: "profile-settings-label",
            inputContainer: "profile-settings-input",
            dropdownContainer: "profile-settings-input",
        },
    });
    const { formData, errors, labelFor, inputPropsFor, inputContainer } = form;
    const { mobileNumber, county, settlement, postalNumber, street, streetNumber } = formData;

    function onSubmit() {
        if (!phoneRegex.test(mobileNumber) && !!mobileNumber.length) return;
        if (mobileNumber !== profile?.mobileNumber || !errors.mobileNumber) {
            dispatch(updateMobileNumber({ mobileNumber, additionalMobileNumber: "" }));
        }

        const countyId = county?.value;
        const settlementId = settlement?.value;
        if (
            countyId == undefined ||
            countyId == null ||
            settlementId == undefined ||
            settlementId == null
        )
            return;

        // Update with new metadata payload
        dispatch(
            updateAccountMetadata({
                countyId,
                settlementId,
                street,
                streetNumber,
                postalNumber,
            })
        );
    }
     const { lowVision } = useContext(AccessibilityContext);
    return (
        <ProfileInfo>
            <AddressForm form={form} />

            {labelFor("mobileNumber", "Kontakt broj")}
            {inputContainer(<Input placeholder="09XXXXXXXX" {...inputPropsFor("mobileNumber")} />)}

            <div className="profile-settings-button ">
                <Button
                    type="submit"
                    variant="primary"
                    lowVision={lowVision}
                    size="small"
                    disabled={!form.isFormDirty}
                    onClick={onSubmit}
                >
                    <span>Spremi izmjene</span>
                </Button>
            </div>
        </ProfileInfo>
    );
};
